<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">تایید کار و پیش فاکتور</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام مشتری</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نوع رسید</label>
          <select class="custom-select" [(ngModel)]="selectedConfirmReceiptDone" name="SubmitPeriodDate">
            <option value="0">در حال کار</option>
            <option value="1">پایان کار</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">

          <button type="button" (click)="getList()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="loading" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>نام مشتری</th>
              <th>شماره نامه</th>
              <th>تاریخ ثبت</th>
              <th>نوع کار</th>
              <th>وضعیت تجهیزات</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list
                  |filter:Filter_title:'customerName' 
                  | paginate: { 
                      id: 'CalibrationConfirmInvoiceTable',
                       itemsPerPage: 50, currentPage: page, totalItems: (list|filter:Filter_title:'customerName').length
                      }">
              <td>{{ list.indexOf(item) + 1 }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.customerName || '-' }}</td>
              <td>{{ item.letterNumber || '-' }}</td>
              <td>{{ item.subDatePersian || '-' }}</td>
              <td>{{ item.inLocation ? 'سایت' : 'آزمایشگاه' }}</td>
              <td>{{ item.confirmedDeviceCount }} / {{ item.totalDeviceCount }}</td>
              <td>
                <div class="btn-group" role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="confirmingId !== item.calibrationId" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">امکانات</button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item" (click)="showDetail(item)"><i
                          class="fa fa-eye"></i> مشاهده جزئیات</a>

                      <a target="_blank" style="cursor: pointer;" class="dropdown-item"
                        [routerLink]="['/LetterRequestCustomerForm',{id:item.letterNumber}]"><i class="fa fa-file"></i> نامه صادره
                      </a>

                      <button type="button" class="dropdown-item"
                        [disabled]="item.confirmedDeviceCount !== item.totalDeviceCount"
                        (click)="openConfirmModal(confirmTemplate, item)"><i class="fa fa-check"></i> تایید
                        نهایی</button>
                    </div>
                  </div>
                  <div *ngIf="confirmingId === item.calibrationId"><img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="!loading && list.length === 0">
              <td colspan="8">رسیدی برای تایید وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="CalibrationConfirmInvoiceTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #confirmTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید نهایی رسید شماره '{{ selectedConfirmReceipt?.code }}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="confirmModalRef.hide()"><span
        aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body">آیا از تایید نهایی کار و پیش فاکتور مشتری '{{ selectedConfirmReceipt?.customerName }}' اطمینان
    دارید؟</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="confirm()">تایید نهایی <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="confirmModalRef.hide()">بستن</button>
  </div>
</ng-template>